<template>
  <div class="job-details__basic-details py-6">
    <div class="d-block">
      <div class="mb-2 d-none d-md-block">
        <h2 class="mb-4">{{ jobName }}</h2>
      </div>
      <dl class="job-details__basic-list">
        <div
          v-if="jobDetails.showStartCode && joboffer.jobCode"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.number</v-icon>
          <dt class="d-inline-flex basic-data">
            <strong class="mr-1">{{ $t('jobs.jobCode') }}</strong>
          </dt>
          <dd>{{ joboffer.jobCode }}</dd>
        </div>

        <div
          v-if="jobDetails.showApplicationStartDate && applicationPeriodStart"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true"
            >$vuetify.icons.dateTime</v-icon
          >
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.publishedOn') }}</strong>
            </dt>
            <dd>{{ applicationPeriodStart }}</dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showApplicationEndDate && applicationPeriodEnd"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true"
            >$vuetify.icons.endDate</v-icon
          >
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{
                $t('jobs.applicationPeriodEndDate')
              }}</strong>
            </dt>
            <dd>{{ applicationPeriodEnd }}</dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showDepartment && localize(joboffer.department)"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.group</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.department') }}</strong>
            </dt>
            <dd>
              {{ localize(joboffer.department) }}
            </dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showCostCenter && localize(joboffer.costCenter)"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.money</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.costCenter') }}</strong>
            </dt>
            <dd>
              {{ localize(joboffer.costCenter) }}
            </dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showTemporaryJob && localize(joboffer.tempJob)"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.info</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.tempJob') }}</strong>
            </dt>
            <dd>
              {{ localize(joboffer.tempJob) }}
              <template v-if="localize(joboffer.tempJobDetails)">
                ({{ localize(joboffer.tempJobDetails) }})
              </template>
            </dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showLocation && localize(joboffer.location)"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.map</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.location') }}</strong>
            </dt>
            <dd>
              {{ localize(joboffer.location) }}
            </dd>
          </div>
        </div>

        <div
          v-if="
            jobDetails.showTimeModel &&
            (localize(joboffer.workingTime) || joboffer.hoursPerWeek)
          "
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.time</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ localize(joboffer.workingTime) }}</strong>
            </dt>
            <dd v-if="joboffer.hoursPerWeek">
              {{ joboffer.hoursPerWeek }} {{ $t('jobs.hoursPerWeek') }}
            </dd>
          </div>
        </div>

        <div v-if="localize(joboffer.extent)" class="mb-4 d-flex">
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.time</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.extent') }}</strong>
            </dt>
            <dd>
              {{ localize(joboffer.extent) }}
            </dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showCareerLevel && localize(joboffer.careerLevel)"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.info</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.careerLevel') }}</strong>
            </dt>
            <dd>
              {{ localize(joboffer.careerLevel) }}
            </dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showSalary && joboffer.salary"
          class="mb-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true">$vuetify.icons.money</v-icon>
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">Gehalt</strong>
            </dt>
            <dd>{{ joboffer.salary }}</dd>
          </div>
        </div>

        <div
          v-if="jobDetails.showStartDate && startDate"
          class="mb-0 mb-md-4 d-flex"
        >
          <v-icon class="mr-2" aria-hidden="true"
            >$vuetify.icons.startDate</v-icon
          >
          <div class="d-inline-flex basic-data">
            <dt>
              <strong class="mr-1">{{ $t('jobs.employmentDate') }}</strong>
            </dt>
            <dd>{{ startDate }}</dd>
          </div>
        </div>
      </dl>

      <div
        v-if="buttons && jobDetails.showApplyButton"
        class="mb-2 mb-md-0 mt-8"
      >
        <job-buttons
          :joboffer="joboffer"
          :block-buttons="blockButtons"
          ref="jobButtons"
          dense
        ></job-buttons>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import jobButtons from '@/components/jobDetails/job-buttons.vue';

export default {
  props: {
    joboffer: {
      type: Object,
      required: true
    },

    jobDetails: {
      type: Object,
      required: true
    },

    buttons: {
      type: Boolean,
      required: false,
      default: true
    },

    blockButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapGetters('companyModule', {
      isInternal: 'userIsInternal'
    }),

    startDate() {
      const startDate = new Date(this.joboffer.employmentStartDate);
      if (startDate < new Date()) {
        return this.$t('jobs.employmentDate_immediately');
      } else {
        return this.$t('jobs.employmentDate_from') + this.$d(startDate);
      }
    },

    applicationPeriodStart() {
      const startDate = new Date(this.joboffer.startDateUtc);
      return this.$d(startDate);
    },

    applicationPeriodEnd() {
      if (!this.joboffer.endDateUtc) {
        return null;
      }

      const endDate = new Date(this.joboffer.endDateUtc);
      return this.$d(endDate);
    },

    jobName() {
      return this.isInternal
        ? this.localize(this.joboffer.internalName) || this.localize(this.joboffer.name)
        : this.localize(this.joboffer.name);
    },
  },

  mounted() {
    if (window.location.href.search(/apply=true/i) >= 0) {
      this.$refs.jobButtons.openApplyDialog();
    }
  },

  components: {
    jobButtons
  }
};
</script>
<style scoped>
.job-details__basic-details {
  line-height: var(--base-line-height);
}

.job-details__basic-list {
  margin: 0;
}

.job-details__basic-list .v-icon.v-icon {
  align-items: baseline;
}

.basic-data {
  flex-wrap: wrap;
}
</style>
